import React, { useEffect, useState } from "react";
import Loader from "../../components/Loader";
import { GlobalFilter } from "../../components/table/FilteringTable/GlobalFilter";
import { Table } from "antd";
import { columns } from "./components/utils";
import { fetchAllRates } from "../../../services/RatesService";

const RateManagement = () => {
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [allRates, setAllRates] = useState([]);
  const [tableParams, setTableParams] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });
  const [showAddModal, setShowAddModal] = useState(false);
  const [viewOrEdit, setViewOrEdit] = useState("none");
  const [selectedRate, setSelectedRate] = useState({});

  useEffect(() => {
    getAllRoles();
  }, []);

  const getAllRoles = () => {
    fetchAllRates()
      .then((res) => {
        const response = res?.data?.result;
        setAllRates(response?.data ?? []);
        setTableParams((prevTableParams) => ({
          ...prevTableParams,
          total: response?.count,
        }));
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
      });
  };

  const handleTableChange = (pagination) => {
    setTableParams(pagination);
  };

  const deleteHandler = (id) => {
    try {
      //   deleteTenant(id)
      //     .then((res) => {
      //       getAllRoles();
      //       swal("Success", "Role Deleted successfully", "success");
      //     })
      //     .catch((error) => {
      //       if (error.response.status === 403) {
      //         swal("Not Authorize", "You are not Authorize to Delete role", "error");
      //       }
      //     });
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <div class="card">
      {loading && <Loader forProcess={true} />}
      <div class="card-header d-sm-flex d-block">
        <div class="me-auto mb-sm-0">
          <h4 class="card-title">Rates Management</h4>
        </div>
        <GlobalFilter filter={searchTerm} setFilter={setSearchTerm} />
        <button className="btn btn-info  light px-2 ms-4">+ Add New Rate</button>
      </div>

      <div class="card-body">
        <Table
          columns={columns(setViewOrEdit, setShowAddModal, setSelectedRate, tableParams, deleteHandler)}
          rowKey={(record) => record.id}
          dataSource={allRates}
          pagination={tableParams}
          onChange={handleTableChange}
        />
      </div>

      {/* add modal */}
    </div>
  );
};

export default RateManagement;
